import { styled } from "@mui/material";

import { TableCell as BaseTableCell } from "@/components/molecules/Table/styled";

export const NoWrapTableCell = styled(BaseTableCell)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
